import React, { useEffect, useRef } from "react";
import { IonPage, IonContent, useIonViewDidEnter } from "@ionic/react";
import { useHistory } from "react-router-dom";
import api from "../services/api";

const LOADER_DELAY_MS = 1000;
const LOADER_TARGET_SECONDS = LOADER_DELAY_MS / 1000;
const MAX_PLAYBACK_RATE = 16;

const Loading: React.FC = () => {
  const history = useHistory();
  const videoRef = useRef<HTMLVideoElement>(null);
  const playStarted = useRef(false);

  const tryPlay = async (attempt = 0) => {
    const video = videoRef.current;
    if (!video || playStarted.current) return;
    playStarted.current = true;
    try {
      await video.play();
      if (video.duration && isFinite(video.duration)) {
        const rate = video.duration / LOADER_TARGET_SECONDS;
        video.playbackRate = Math.min(Math.max(rate, 1), MAX_PLAYBACK_RATE);
      }
    } catch {
      // play() rigettato (es. animazione ancora in corso): riprova
      playStarted.current = false;
      if (attempt < 4) {
        setTimeout(() => void tryPlay(attempt + 1), 250);
      }
    }
  };

  // Scatta dopo che l'animazione di entrata della pagina Ionic è completata:
  // il momento più affidabile per chiamare play() su iOS WKWebView.
  useIonViewDidEnter(() => {
    void tryPlay();
  });

  useEffect(() => {
    let mounted = true;
    const goNext = async () => {
      const delay = (ms: number) => new Promise<void>((r) => setTimeout(r, ms));
      try {
        await delay(LOADER_DELAY_MS);
        // Valida sessione + notifica primo accesso (webhook Discord via n8n)
        await api.get("/me", { skipAuthRedirect: true } as any);
        const r = await api.get("/cards/me", { skipAuthRedirect: true } as any);
        if (!mounted) return;
        if (r.data && r.data.id) {
          history.replace(`/card/${r.data.id}`);
        } else {
          history.replace("/create");
        }
      } catch (e: any) {
        // 401: interceptor reindirizza a login — non aprire editor vuoto
        if (e?.response?.status === 401 || e?.response?.status === 403) return;
        history.replace("/create");
      }
    };
    goNext();
    return () => {
      mounted = false;
    };
  }, [history]);

  return (
    <IonPage>
      <IonContent fullscreen style={{ "--background": "transparent" } as any}>
        <div
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#181818",
          }}
        >
          <video
            ref={videoRef}
            src="/assets/loader.mp4"
            autoPlay
            muted
            playsInline
            preload="auto"
            style={{
              height: "50%",
              objectFit: "cover",
              pointerEvents: "none",
            }}
            onCanPlay={() => void tryPlay()}
          />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Loading;
